import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoBloqueioVeiculoPreFaturaGerada({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(
      api.get,
      'operacaobloqueioveiculoprefaturagerada',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* veiculosBloqueadosPreFaturaGeradaInRequest({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(
      api.get,
      'operacaobloqueioveiculoprefaturageradahistoricoitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoBloqueioVeiculoPreFaturaGerada({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(
      api.delete,
      `operacaobloqueioveiculoprefaturagerada/${fatu_codigo}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaobloqueioveiculoprefaturagerada, params } = payload;

    yield call(
      api.post,
      'operacaobloqueioveiculoprefaturagerada',
      operacaobloqueioveiculoprefaturagerada
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaobloqueioveiculoprefaturagerada/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* findVeiculo({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaobloqueioveiculoprefaturageradahistoricoitem/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaobloqueioveiculoprefaturagerada, params } = payload;

    yield call(
      api.put,
      'operacaobloqueioveiculoprefaturagerada',
      operacaobloqueioveiculoprefaturagerada
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(
      api.get,
      'operacaobloqueioveiculoprefaturagerada',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFiltersVeiculo({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(
      api.get,
      'operacaobloqueioveiculoprefaturageradahistoricoitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}
//operacaobloqueioveiculoprefaturas
//OPERACAO
export default all([
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/BLOQUEIOVEICULOS_IN_REQUEST',
    requestOperacaoBloqueioVeiculoPreFaturaGerada
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/DELETE_BLOQUEIOVEICULOS',
    deleteOperacaoBloqueioVeiculoPreFaturaGerada
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/SUCCESS_REMOVE',
    requestOperacaoBloqueioVeiculoPreFaturaGerada
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/STORE_BLOQUEIOVEICULOS',
    store
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/FIND_BLOQUEIOVEICULOS',
    find
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/FIND_VEICULOSPREGERADA',
    findVeiculo
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/UPDATE_BLOQUEIOVEICULOS',
    update
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING',
    applyedFilters
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING_VEICULO',
    applyedFiltersVeiculo
  ),
]);
